import React from "react";

interface ITextAltIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const TextAltIcon: React.FC<ITextAltIconProps> = ({ sizeX = 19, sizeY = 18 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 4V1H17.5V4M6.5 17H12.5M9.5 1V17" stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
